import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-claim-summary',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, FormsModule],
  templateUrl: './claim-summary.component.html',
  styleUrls: ['./claim-summary.component.css']
})
export class ClaimSummaryComponent {
  laborCost = input<number>(0);
  partsCost = input<number>(0);
  totalCost = input<number>(0);
  totalDeductible = input<number>(0);
  netReimbursement = input<number>(0);
  isTotalLoss = input<boolean>(false);
  vehicleValue = input<number>(0);
  retentionPct = input<number>(15);
  /** Negligencia del claim (maestro). */
  isNegligence = input<boolean | null>(null);
  /** Edición gobernada por BPM (p. ej. rol requerido / revisor final). */
  canEditNegligence = input<boolean>(false);

  negligenceChange = output<boolean>();

  onNegligenceToggle(value: boolean) {
    this.negligenceChange.emit(value);
  }
}
